import { createSelector } from "reselect";
import { path, prop, identity, filter, equals } from "ramda";

import { isUIComponentVisible } from "~/utils";

// Selectors
const getSidebarLeft = path(["domain", "ui", "sidebarLeft"]);

export const selectSidebarLeft = createSelector(getSidebarLeft, identity);

export const selectIsSidebarLeftVisible = createSelector(
  getSidebarLeft,
  isUIComponentVisible
);

export const selectShowPlannerTab = createSelector(
  getSidebarLeft,
  prop("showPlannerTab")
);

export const selectShowPagesTab = createSelector(
  getSidebarLeft,
  prop("showPagesTab")
);

export const selectShowOutlineTab = createSelector(
  getSidebarLeft,
  prop("showOutlineTab")
);

export const selectShowBookmarksTab = createSelector(
  getSidebarLeft,
  prop("showBookmarksTab")
);

export const selectActiveTabs = createSelector(
  selectShowPlannerTab,
  selectShowPagesTab,
  selectShowOutlineTab,
  selectShowBookmarksTab,
  (planner, pages, outline, bookmarks) => ({
    planner,
    pages,
    outline,
    bookmarks
  })
);

export const selectVisibleTabs = createSelector(
  selectActiveTabs,
  filter(equals(true))
);

export const selectHasSingleTab = createSelector(
  selectVisibleTabs,
  tabs => tabs.length === 1
);

export const selectVisibleTabNames = createSelector(selectVisibleTabs, tabs =>
  Object.keys(tabs)
);

export const selectFirstVisibleTab = createSelector(selectVisibleTabs, tabs => {
  const keys = Object.keys(tabs);

  if (keys.length < 1) {
    return null;
  }

  return keys[0];
});

// Initial State
const initialState = () => ({
  showPlannerTab: false,
  showPagesTab: true,
  showOutlineTab: true,
  showBookmarksTab: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
